<section class="block4__container container-fluid">
        <div class="container g-0 px-2">
            <h2 class="block__info__titlte">
                {{ 'fe_title_block4_home' | translate }}
            </h2>
            <div class="d-flex flex-column flex-md-row contain__b4">
                <div class="d-flex flex-column flex-md-row align-items-start">
                    <img
                        [src]="'images/search-img.svg' | cdn"
                        alt="buscar reserva"
                        class="block__info__img d-none d-md-block pe-2"
                    />
                    <div class="block__info__container">
                        <h3 class="block__info__subtitlte pb-2">
                            {{ 'fe_subtitle_block4_home' | translate }}
                        </h3>
                        <p class="block__info__description">
                            {{ 'fe_description_block4_home' | translate }}
                        </p>
                        <a
                            class="block__info__link"
                            [routerLink]="'check-your-reservation' | formatUrl"
                        >
                            {{ 'fe_txtlink_block4_home' | translate }}
                            <span
                                class="material-symbols-outlined chevron-right"
                                >chevron_right</span
                            >
                        </a>
                    </div>
                </div>
                <div class="d-flex flex-column flex-md-row align-items-start">
                    <img
                        [src]="'images/check.svg' | cdn"
                        alt="check_in"
                        class="block__info__img d-none d-md-block pe-2"
                    />
                    <div class="block__info__container">
                        <h3 class="block__info__subtitlte pb-2">
                            {{ 'fe_subtitle2_block4_home' | translate }}
                        </h3>
                        <p class="block__info__description">
                            {{ 'fe_description2_block4_home' | translate }}
                        </p>
                        <a
                            class="block__info__link"
                            [routerLink]="'pre-check-in' | formatUrl"
                            >{{ 'fe_txtlink2_block4_home' | translate }}
                            <span
                                class="material-symbols-outlined chevron-right"
                                >chevron_right</span
                            >
                        </a>
                    </div>
                </div>
            </div>
        </div>
</section>
